import React from "react"
import styles from "./panel.module.scss"
import {combineClasses} from "../../util/class-utils"

interface PanelProps {
  fullWidth?: boolean
  className?: string
}

export const Panel: React.FC<PanelProps> = ({fullWidth, className, children}) => {
  return <div className={combineClasses([fullWidth ? styles.FullWidthPanel : styles.Panel, className])}>{children}</div>
}